/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationNeedsSubscribersQuery from '../graphql/queries/GetSimulationNeedsSubscribersQuery.js';

const useGetSimulationNeedsSubscribersQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationNeedsSubscribersQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationNeedsSubscribers: R.omit(['__typename'], data?.getSimulationNeedsSubscribers_simulation_needs || {})
  };
};

export default useGetSimulationNeedsSubscribersQuery;
